import * as React from 'react';
import { Props, propTypes } from './props';
import { Checkbox, Button, Grid } from 'semantic-ui-react';

interface State {
  filter?: boolean;
}

export default class BooleanFilter extends React.Component<Props, State> {
  static propTypes = propTypes;

  constructor(props: Props) {
      super(props);

      this.state = {
          filter: undefined
      };

      this.onClear = this.onClear.bind(this);
      this.onApply = this.onApply.bind(this);
      this.isFilterActive = this.isFilterActive.bind(this);
      this.doesFilterPass = this.doesFilterPass.bind(this);
      this.getModel = this.getModel.bind(this);
      this.setModel = this.setModel.bind(this);
      this.toggle = this.toggle.bind(this);
  }

  isFilterActive() {
    return this.state.filter !== undefined;
  }

  // tslint:disable-next-line:no-any
  doesFilterPass(params: any) {      
      const value = this.props.valueGetter(params.node);
      return this.state.filter === undefined ? true : value === this.state.filter;
  }

  getModel() {
    return {filter: this.state.filter};
  }

  // tslint:disable-next-line:no-any
  setModel(model: any) {
    const filter = model ? model.filter : undefined;
    this.setState({filter: filter});
  }

  toggle() {
    this.setState({ filter: !this.state.filter });
  }

  onClear() {
    this.setState({filter: undefined}, () => {
      this.props.filterChangedCallback();
  });
  }

  onApply() {
    this.setState({filter: this.state.filter}, () => {
        this.props.filterChangedCallback();
    });
  }
  
  render() {
    return (
      <Grid columns={1} padded="horizontally">
        <Grid.Row>
          <Grid.Column>
            <Checkbox onChange={this.toggle} checked={this.state.filter} label="Filter" />
            <br/>
            <div style={{marginTop: 10}}>
              <Button 
                className="neutral-dark" 
                size="mini" 
                onClick={this.onApply}>
                Apply
              </Button>
              <Button 
                color="red"
                className="neutral-dark" 
                size="mini" 
                onClick={this.onClear}>
                Clear
              </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/filters/boolean/component.tsx